var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledLn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.5H15.5V26.5H17.5V18.5Z",
    fill: "#5F6774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9205 18.5252C24.8254 18.514 24.7244 18.5084 24.6233 18.5028C23.179 18.4468 22.3648 19.2532 22.0795 19.6004C22.0022 19.6956 21.9666 19.7516 21.9666 19.7516V18.7156H19.5V26.4664H21.9666H22.0795C22.0795 25.6768 22.0795 24.8927 22.0795 24.1031C22.0795 23.6775 22.0795 23.2518 22.0795 22.8262C22.0795 22.2998 22.0379 21.7397 22.3172 21.2581C22.555 20.8549 22.9829 20.6533 23.4643 20.6533C24.8908 20.6533 24.9205 21.8686 24.9205 21.9806C24.9205 21.9862 24.9205 21.9918 24.9205 21.9918V26.5H27.5V21.4429C27.5 19.7124 26.5669 18.6932 24.9205 18.5252Z",
    fill: "#5F6774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 17.5C17.2404 17.5 17.8 16.9404 17.8 16.25C17.8 15.5596 17.2404 15 16.55 15C15.8597 15 15.3 15.5596 15.3 16.25C15.3 16.9404 15.8597 17.5 16.55 17.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledLn);
export default __webpack_public_path__ + "static/media/filledLn.99e6a5bdf9598ddc05b58edf0dc1f2a8.svg";
export { ForwardRef as ReactComponent };